import Vue from 'vue'

import Cs from '@@/cs/Cs'
import Settings from '@@/settings/Settings'
import settOpts from './_sett'

import axios from 'axios'
import Table from '@@/database/Table'

const tm$ = (dt, data) => new Promise(r => setTimeout(_ => r(data), dt))

class Database {
    get CLASS() { return 'Database' }
    constructor(CS, dbPath='/static/db/dt/') {
        this.CS = CS
        this.dbPath = dbPath
        this.tblNames = ['team', 'journals', 'conferences', 'papers', 'plan', 'events']
        this.tblNamesLoaded = []
        this.isStarted = false
        this.tblNames.forEach(tblName => {
            this[tblName] = new Table(tblName)
        })
    }
    start$() {
        this.isStarted = true
        console.log('this.isStarted')
        //return
        return Promise.all(this.tblNames.map(n => this.download$(n)))
    }
    download$(tblName) {
        this.CS.debug(`Start loading "${tblName}"`, this.CLASS, 'download$')
        const tbl = this[tblName]
        return axios.get(this.dbPath + tbl.name + '.json')
            .then(res => tm$(2, res))
            .then(res => {
                tbl.parse(res.data)
                tbl.isLoaded = true
                this.tblNamesLoaded.push(tblName)
                this.CS.debug(
                    `Table "${tblName}" is loaded`,
                    this.CLASS, 'download$')
                return tbl
            })
            .catch(err => {
                this.CS.err(
                    `Error while loading table "${tblName}"`,
                    this.CLASS, 'download$', err)
            })
            .then(res => tm$(2, res))
            .then(res => this.parse$())
    }
    parse$() {
        return Promise.all(this.tblNames.map(tblName => {
            return Promise.all(this.tblNames.map(tblNameRef => {
                return Promise.resolve(this[tblName].extend(this[tblNameRef]))
            }))
        }))
    }
}

function mixin_(app='app', isDebug=true) {
    const CS = new Cs({
      app       : app,
      fatal     : true,
      err       : true,
      warn      : true,
      res       : true,
      proc      : true,
      debug     : true,
      debugCn   : true,
      debugDb   : true,
      debugRb   : true,
      debugSt   : true,
      write     : isDebug,
    })
    const ST = new Settings(settOpts, {}, app, 'global')
    const DB = new Database(CS)

    Vue.mixin({
        data() {
            return {
                CS,
                ST,
                DB,
                windowW: 0,
                windowH: 0,
            }
        },
        computed: {
            CLASS() {
                return this.$options.name
            },
            LANG() {
                return this.ST ? this.ST.lang : 'en'
            },
            isENG() {
                return this.LANG == 'en'
            },
            isRUS() {
                return this.LANG == 'ru'
            },
            teamTbl() {
                return this.DB['team']
            },
            journalsTbl() {
                return this.DB['journals']
            },
            conferencesTbl() {
                return this.DB['conferences']
            },
            papersTbl() {
                return this.DB['papers']
            },
            planTbl() {
                return this.DB['plan']
            },
            eventsTbl() {
                return this.DB['events']
            },
        },
        watch: {
            LANG() {
                this.$moment.locale(this.LANG)
                this.$emit('updateHead')
            },
        },
        created() {
            //this.CS.debug(`***`, this.$options.name, 'created')
        },
        mounted() {
            //this.CS.debug(`***`, this.CLASS, 'mounted')
            this.updWindowW()
            this.updWindowH()
            this.$nextTick(_ => {
                window.addEventListener('resize', this.updWindowW)
                window.addEventListener('resize', this.updWindowH)
            })
            if(!this.DB.isStarted)
                this.DB.start$()
        },
        beforeDestroy() {
            //this.CS.debug(`***`, this.CLASS, 'beforeDestroy')
            window.removeEventListener('resize', this.updWindowW)
            window.removeEventListener('resize', this.updWindowH)
        },
        destroyed() {
            //this.CS.debug(`***`, this.CLASS, 'destroyed')
        },
        methods: {
            updWindowW() {
                this.windowW = parseInt(
                    document.documentElement.clientWidth, 10)
            },
            updWindowH() {
                this.windowH = parseInt(
                    document.documentElement.clientHeight, 10)
            },
            _parseDate(date) {
                let format = this.isENG ? 'MMMM D, YYYY' : 'D MMMM, YYYY'
                return this.$moment(date).format(format)
            },
        },
    })
}

export default mixin_



// WEBPACK FOOTER //
// ./main/mixin.js